import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./CreatorPage.css";

const CreatorPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="creator-page">
      <Navbar />
      <main className="creator-main">
        <section className="creator-card">
          <p className="creator-kicker">Website Creator</p>
          <h1 className="creator-title">Sohail Asghar</h1>
          <p className="creator-text">
            Rung Do was proudly designed and developed by Mr. Sohail Asghar (Senior Full Stack Developer).
          </p>
          <a
            className="creator-portfolio-link"
            href="https://sohailasghar.site/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit Portfolio
          </a>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CreatorPage;
